import { ShopifyPage } from '../../types/shopify';

/**
 * Transforms a Shopify page into a format that can be used by the application
 */
export const transformShopifyPage = (shopifyPage: ShopifyPage) => {
  try {
    console.log('Transforming Shopify page:', shopifyPage.id, shopifyPage.title);
    
    return {
      id: shopifyPage.id,
      title: shopifyPage.title,
      handle: shopifyPage.handle,
      content: shopifyPage.body,
      summary: shopifyPage.bodySummary,
      createdAt: new Date(shopifyPage.createdAt),
      updatedAt: new Date(shopifyPage.updatedAt),
      url: shopifyPage.url
    };
  } catch (error) {
    console.error('Error transforming Shopify page:', error);
    return null;
  }
};

/**
 * Transforms an array of Shopify pages into an array of application-compatible page objects
 */
export const transformShopifyPages = (shopifyPages: ShopifyPage[]) => {
  console.log(`Transforming ${shopifyPages.length} Shopify pages`);
  
  if (!Array.isArray(shopifyPages)) {
    console.error('shopifyPages is not an array:', shopifyPages);
    return [];
  }
  
  const transformedPages = shopifyPages.map(page => {
    try {
      return transformShopifyPage(page);
    } catch (error) {
      console.error('Error transforming page:', error);
      return null;
    }
  }).filter(page => page !== null);
  
  console.log(`Successfully transformed ${transformedPages.length} pages`);
  return transformedPages;
};
